import $ from 'jquery';
import 'imports?jQuery=jquery!bxslider/src/js/jquery.bxslider';
import 'imports?jQuery=jquery!./TweenMax.js';
import 'imports?jQuery=jquery!./jquery.superscrollorama.js';

$(() => {
	var $b = $('body');

	$('.console-catalog__info-more').on('click', function(e){
		e.preventDefault();
		$('.modal').toggleClass('modal_show');
	});

	$('.modal__close').on('click', function(e){
		e.preventDefault();
		$('.modal').removeClass('modal_show');
	});

	$('.where-buy__more').on('click', function(e){
		e.preventDefault();
		if (!$(this).hasClass('active')){
			$(this).addClass('active')
			$.ajax({
				url: 'index.html',
				dataType: 'html',
				success: function(html) {
					var div = $('.where-buy__item', $(html)).addClass('done');
						$('.where-buy__list').addClass('loaded').append(div);
					}
			});
		} else {
			$(this).removeClass('active');
			$('.where-buy__container .where-buy__item.done').remove();
		}
	});

	if ($b.width() >= 1024){
		$('.promo-carousel__container').bxSlider({
			mode: 'vertical',
			slideSelector: '.promo-carousel__slide',
			adaptiveHeight: true,
			preloadImages: 'all',
			touchEnabled: false,
			controls: false
		});

		var $w = $(window);
		var $header = $('.header-menu__list');
		$w.on('scroll', function(e){
			if ($w.scrollTop() > 0){
				$header.addClass('header-menu__list_fixed');
			} else {
				$header.removeClass('header-menu__list_fixed');
			};

			var scrollPos = $w.scrollTop();
			$('.header-menu__link').each(function () {
				var currLink = $(this);
				var refElement = $(currLink.attr("href"));
				if (refElement.position().top - 300 <= scrollPos && refElement.position().top + refElement.height() > scrollPos) {
					$('.header-menu__link').removeClass("header-menu__link_active");
					currLink.addClass("header-menu__link_active");
				} else {
					currLink.removeClass("header-menu__link_active");
				}
			});
		});

		var controller = $.superscrollorama({
			// triggerAtCenter: false,
			playoutAnimations: false
		});

		$('.reviews__list').bxSlider({
			controls: false,
			onSliderLoad: function(){
				controller.addTween('.reviews__container .reviews__list-wrapper', TweenMax.from( $('.reviews__container .reviews__list-wrapper'), 1.0, {delay: 0.2, css:{opacity: 0 , rotationY:180, transformOrigin:"left 50% -100"}, ease: Cubic.easeOut}),0 , -300)
			}
		});

		$('.console-carousel').bxSlider({
			minSlides: 1,
			maxSlides: 3,
			slideWidth: 180,
			controls: false,
			onSliderLoad: function(){
				controller.addTween('.console-catalog__carousel', TweenMax.from( $('.console-catalog__carousel'), 1.0, {delay: 1.0, css:{opacity: 0 , rotationY:-270, transformOrigin:"right 50% -200"}, ease: Cubic.easeOut}),0 , -250)
			}
		});

		$('.features-carousel').bxSlider({
			pager: false,
			onSliderLoad: function(){
				controller.addTween('.features__carousel-wrapper', TweenMax.from( $('.features__carousel-wrapper'), 0.8, {delay: 1.4, css:{opacity: 0 ,scale: 0.2, rotationZ: 90}, ease: Cubic.easeOut}),0 ,-250)
			}
		});

		controller
			.addTween('.console-catalog__line', TweenMax.from( $('.console-catalog__line'), 1.0, {delay: 0.0, css:{opacity: 0 , rotationY:-180, transformOrigin:"right 50% -100"}, ease: Cubic.easeOut}),0 , -250)
			.addTween('.console-catalog__title', TweenMax.from( $('.console-catalog__title'), 1.0, {delay: 0.2, css:{opacity: 0 , rotationY:180, transformOrigin:"left 50% -100"}, ease: Cubic.easeOut}),0 , -250)
			.addTween('.console-catalog__subtitle', TweenMax.from( $('.console-catalog__subtitle'), 1.0, {delay: 0.4, css:{opacity: 0 , rotationY:-180, transformOrigin:"right 50% -100"}, ease: Cubic.easeOut}),0 , -250)
			.addTween('.console-catalog__info', TweenMax.from( $('.console-catalog__info'), 1.0, {delay: 1.0, css:{opacity: 0 , rotationY:270, transformOrigin:"left 50% -200"}, ease: Cubic.easeOut}),0 , -250)
			// .addTween('.console-catalog__carousel', TweenMax.from( $('.console-catalog__carousel'), 1.0, {delay: 1.0, css:{opacity: 0 , rotationY:-270, transformOrigin:"right 50% -200"}, ease: Cubic.easeOut}),0 , -250)
			//
			.addTween('.features__title', TweenMax.from( $('.features__title'), 1.0, {delay: 1.0, css:{opacity: 0 , rotationY:180, transformOrigin:"left 50% -100"}, ease: Cubic.easeOut}),0 , -250)
			.addTween('.features__line', TweenMax.from( $('.features__line'), 1.3, {delay: 0.6, css:{opacity: 0 , rotationY:-180, transformOrigin:"right 50% -100"}, ease: Cubic.easeOut}),0 , -250)
			// .addTween('.features__carousel-wrapper', TweenMax.from( $('.features__carousel-wrapper'), 0.8, {delay: 1.4, css:{opacity: 0 ,scale: 0.2, rotationZ: 90}, ease: Cubic.easeOut}),0 ,-250)
			.addTween('.features', TweenMax.from( $('.features'), 0.5, {delay: 0.0, css:{ opacity: 0 ,scale: 0.2, rotationX: 90}, ease: Cubic.easeOut}),0 ,-250)
			.addTween('.features__text p', TweenMax.from( $('.features__text p'), .7, {delay: 1.6, css:{bottom: '-30px', opacity: 0}, ease: Cubic.easeOut}),0 , -300)
			//
			.addTween('.where-buy__title', TweenMax.from( $('.where-buy__title'), 1.0, {delay: 0.2, css:{opacity: 0 , rotationY:180, transformOrigin:"left 50% -100"}, ease: Cubic.easeOut}),0 , -300)
			.addTween('.where-buy__text', TweenMax.from( $('.where-buy__text'), 1.0, {delay: 0.4, css:{opacity: 0 , rotationY:-180, transformOrigin:"right 50% -100"}, ease: Cubic.easeOut}),0 , -300)
			.addTween('.where-buy__line', TweenMax.from( $('.where-buy__line'), 1.0, {delay: 0.0, css:{opacity: 0 , rotationY:-180, transformOrigin:"right 50% -100"}, ease: Cubic.easeOut}),0 , -300)
			.addTween('.where-buy__item:nth-child(1)', TweenMax.from( $('.where-buy__item:nth-child(1)'), 1.0, {delay: 1.8, css:{opacity: 0 , rotationY:270, transformOrigin:"left 50% -200"}, ease: Cubic.easeOut}),0 , -300)
			.addTween('.where-buy__item:nth-child(2)', TweenMax.from( $('.where-buy__item:nth-child(2)'), 1.0, {delay: 1.8, css:{opacity: 0 , rotationY:-270, transformOrigin:"right 50% -200"}, ease: Cubic.easeOut}),0 , -300)
			.addTween('.where-buy__item:nth-child(3)', TweenMax.from( $('.where-buy__item:nth-child(3)'), 1.0, {delay: 2.8, css:{opacity: 0 , rotationY:270, transformOrigin:"left 50% -200"}, ease: Cubic.easeOut}),0 , -300)
			.addTween('.where-buy__item:nth-child(4)', TweenMax.from( $('.where-buy__item:nth-child(4)'), 1.0, {delay: 2.8, css:{opacity: 0 , rotationY:-270, transformOrigin:"right 50% -200"}, ease: Cubic.easeOut}),0 , -300)
			//
			 // .addTween('.reviews__container .reviews__list-wrapper', TweenMax.from( $('.reviews__container .reviews__list-wrapper'), 1.0, {delay: 0.2, css:{opacity: 0 , rotationY:180, transformOrigin:"left 50% -100"}, ease: Cubic.easeOut}),0 , -300)
			//
			.addTween('.contacts__title', TweenMax.from( $('.contacts__title'), 1.0, {delay: 0.2, css:{opacity: 0 , rotationY:180, transformOrigin:"left 50% -100"}, ease: Cubic.easeOut}),0 , -300)
			.addTween('.contacts__subtitle', TweenMax.from( $('.contacts__subtitle'), 1.0, {delay: 0.4, css:{opacity: 0 , rotationY:-180, transformOrigin:"right 50% -100"}, ease: Cubic.easeOut}),0 , -300)
			.addTween('.contacts__line', TweenMax.from( $('.contacts__line'), 1.0, {delay: 0.0, css:{opacity: 0 , rotationY:-180, transformOrigin:"right 50% -100"}, ease: Cubic.easeOut}),0 , -300)
			.addTween('#name', TweenMax.from( $('#name'), 1.0, {delay: 0.2, css:{opacity: 0 , rotationY:180, transformOrigin:"left 50% -100"}, ease: Cubic.easeOut}),0 , -300)
			.addTween('#email', TweenMax.from( $('#email'), 1.0, {delay: 0.8, css:{opacity: 0 , rotationY:180, transformOrigin:"left 50% -100"}, ease: Cubic.easeOut}),0 , -300)
			.addTween('#phone', TweenMax.from( $('#phone'), 1.0, {delay: 0.8, css:{opacity: 0 , rotationY:180, transformOrigin:"left 50% -100"}, ease: Cubic.easeOut}),0 , -300)
			.addTween('#message', TweenMax.from( $('#message'), 1.0, {delay: 1.4, css:{opacity: 0 , rotationY:180, transformOrigin:"left 50% -100"}, ease: Cubic.easeOut}),0 , -300)
			.addTween('.contact-form__submit', TweenMax.from( $('.contact-form__submit'), 1.0, {delay: 2.0, css:{opacity: 0 , rotationY:-180, transformOrigin:"right 50% -100"}, ease: Cubic.easeOut}),0 , -500)
			.addTween('.contact-form__file', TweenMax.from( $('.contact-form__file'), 1.0, {delay: 2.0, css:{opacity: 0 , rotationY:-180, transformOrigin:"right 50% -100"}, ease: Cubic.easeOut}),0 , -500)
			.addTween('.contacts__item_address', TweenMax.from( $('.contacts__item_address'), 1.0, {delay: 0.8, css:{opacity: 0 , rotationY:-180, transformOrigin:"right 50% -100"}, ease: Cubic.easeOut}),0 , -300)
			.addTween('.contacts__item_phone', TweenMax.from( $('.contacts__item_phone'), 1.0, {delay: 1.2, css:{opacity: 0 , rotationY:-180, transformOrigin:"right 50% -100"}, ease: Cubic.easeOut}),0 , -300)
			.addTween('.contacts__item_email', TweenMax.from( $('.contacts__item_email'), 1.0, {delay: 1.2, css:{opacity: 0 , rotationY:-180, transformOrigin:"right 50% -100"}, ease: Cubic.easeOut}),0 , -500)

	} else{
		$('.console-carousel').bxSlider({
			controls: false
		});
		$('.reviews__list').bxSlider({
			controls: false
		});
		$('.features-carousel').bxSlider({
			pager: false
		});
		$('.promo-carousel__container').bxSlider({
			slideSelector: '.promo-carousel__slide',
			adaptiveHeight: true,
			touchEnabled: true,
			controls: false
		});
	};

});



// WEBPACK FOOTER //
// ./app/scripts/app.js